<div *ngIf="isGenerating">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div class="bootstrap-wrapper">
    <div *ngIf="!error && reportData" id="onemap-report" class="sd-bridge-report">
        <div class="reportContainer">
            <div class="squareReportSectionHeader">
                <label>Poor Bridge Condition Report</label><label style="margin-right:10px;" class="pull-right">{{ todaysDate }}</label>
            </div>
            <div class="bridgeTableSection">
                <table class="bridgeTable table-condensed table" aria-label="Poor Bridge Condition Report<">
                    <thead>
                        <tr>
                            <th>Proj. ID</th>
                            <th>Proj. Title</th>
                            <th>Improv. Type</th>
                            <th>Route</th>
                            <th>County</th>
                            <th>TYP App</th>
                            <th>TIP App</th>
                            <th>Let Date</th>
                            <th>Let IND</th>
                            <th>Bridge Work</th>
                            <th>BMS ID</th>
                            <th>Bridge Key</th>
                            <th>Location Description</th>
                            <th>Status Cde</th>
                            <th>Deficient/Obselete</th>
                            <th>Sufficiency Rating</th>
                            <th>Bridge Bill</th>
                            <th>Year Built</th>
                            <th>Length</th>
                            <th>Deck Width</th>
                            <th>Deck Area</th>
                            <th>HBRR Elig.</th>
                            <th>Bus Plan Network</th>
                            <th>Long.</th>
                            <th>Lat.</th>
                            <th>Post Limit Weight</th>
                            <th>Post Limit Comb.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of reportData.sdBridgeReports" class="{{ row.stateLocal | lowercase }}">
                            <td><a href="?projectId={{ row.projectId }}" target="blank">{{ row.projectId }}</a></td>
                            <td>{{ row.projectTitle }}</td>
                            <td>{{ row.improvementShortDesc }}</td>
                            <td>{{ row.stRtNo }}</td>
                            <td>{{ row.ctyCode }}</td>
                            <td>{{ row.typApp }}</td>
                            <td>{{ row.tipApp }}</td>
                            <td>{{ row.letDate }}</td>
                            <td>{{ row.letInd }}</td>
                            <td>{{ row.bridgeWork }}</td>
                            <td>{{ row.bridgeId }}</td>
                            <td><a href="?brKey={{ row.brKey }}&mapId=undefined" target="blank">{{ row.brKey }}</a></td>
                            <td>{{ row.location }}</td>
                            <td>{{ row.postStatus }}</td>
                            <td>{{ row.nbiRating }}</td>
                            <td>{{ row.suffRate }}</td>
                            <td>{{ row.bridgeBill }}</td>
                            <td>{{ row.yearBuilt }}</td>
                            <td>{{ row.length }}</td>
                            <td>{{ row.deckWidth }}</td>
                            <td>{{ row.deckArea }}</td>
                            <td>{{ row.hbrrElig }}</td>
                            <td>{{ row.busPlanNetwork }}</td>
                            <td>{{ row.declat }}</td>
                            <td>{{ row.decLong }}</td>
                            <td>{{ row.postLimitWeight }}</td>
                            <td>{{ row.postLimitComb }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
